// #region Imports
import { defineComponent, nextTick } from "vue";
import { appWindow } from "../../../classes/Windows";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-modal-slide',
    // #endregion
    // #region Properties
    props: {
        id: {
            type: String,
            required: true
        },
        position: {
            type: String,
            default: 'right'
        },
        size: {
            type: String,
            default: 'default'
        },
        closeOnKeyEsc: {
            type: Boolean,
            required: false,
            default: true
        },
        closeOnOutsideClick: {
            type: Boolean,
            required: false,
            default: true
        },
        closable: {
            type: Boolean,
            required: false,
            default: true
        },
        window: {
            type: Object,
            required: false
        },
        parentWindow: {
            type: Object,
            required: false
        },
        windowCallback: {
            type: Function,
            required: false,
            default: null
        },
    },
    data: () => ({
        visible: false,
        visible2: false
    }),
    computed: {
        modalClasses() {
            return {
                [`position-${this.position}`]: this.position,
                [`size-${this.size}`]: this.size,
            };
        },
        identifierClass() {
            return `g-modal--${this.id}`;
        },
    },
    // #endregion
    // #region Constructor
    created() {
        // #region Data
        this.appWindow = new appWindow(this.$appHost, this, this.parentWindow);
        // #endregion
        // #region Host
        let tWindow = this.$appHost.notification.getWindowByID(this.id);
        {
            if (tWindow) {
                tWindow.appWindow = this.appWindow;
            }
        }
        // #endregion
        // #region Show
        this.show();
        // #endregion
    },
    mounted() {
        // #region Window
        this.appWindow?.mount();
        // #endregion
        // #region Focus
        this.setFocusToModal();
        // #endregion
    },
    unmounted() {
        // #region Window
        this.appWindow?.unmount();
        // #endregion
    },
    // #endregion
    // #region Core
    methods: {
        setFocusToModal() {
            let tDialog = this.$refs.dialog;
            this.$nextTick(() => {
                tDialog.focus();
            });
        },
        show() {
            this.visible = true;
            nextTick(() => {
                this.visible2 = true;
            });
        },
        close(state) {
            // #region Self
            this.visible2 = false;
            // #endregion
            // #region Timer
            setTimeout(() => {
                //Meta
                if (this.window) {
                    this.$router.closeWindow(this.window);
                }
                else {
                    this.$appHost.notification.closeModal(this.id);
                }
                //Callback
                if (this.windowCallback) {
                    if (utils.isObject(state)) {
                        this.windowCallback(state);
                    }
                    else {
                        this.windowCallback({
                            state: state ?? 0
                        });
                    }
                }
            }, 500);
            // #endregion
        },
        closeModalOnClickOutside(domEvent) {
            //vars
            let tDialog = this.$refs.dialog;
            //Check
            if (!this.closeOnOutsideClick) {
                return;
            }
            if (utils.isNull(tDialog)) {
                return;
            }
            if (tDialog.contains(domEvent.target)) {
                return;
            }
            //Close
            this.close();
        },
        closeModalOnEscapeKey(event) {
            //Check
            if (!this.closeOnKeyEsc) {
                return;
            }
            if (event.target !== document.activeElement) {
                return;
            }
            if (event.key === 'Escape' || event.keyCode === 27) {
                this.close();
            }
        }
    }
    // #endregion
});
// #endregion
